import ImageGallerySection from '../components/Common/PlatformHeroSection';
import ChallengesSection from '../components/Common/PlatformSection';
import InfoCarouselSection from '../components/Common/PlatformCardSection';
import OutcomesSection from '../components/Common/PlatformOutcomeSection';
import PrivacyEthicsSection from '../components/Behavioral/PrivacyEthicsSection';

const BehavioralHealth = () => {
  const heroButtons = [
    {
      label: 'Learn More',
      className: 'btn-secondary',
      onClick: () => {
        document.getElementById('gallery-section').scrollIntoView({ behavior: 'smooth' });
      },
    },
  ];

  const galleryImages = [
    {
      src: '/assets/platformBehavioral/hero1.svg',
      alt: 'Doctor examining child',
    },
    {
      src: '/assets/platformBehavioral/hero2.svg',
      alt: 'Healthcare professional',
    },
    {
      src: '/assets/platformBehavioral/hero3.svg',
      alt: 'Doctor with patient',
    },
    {
      src: '/assets/platformBehavioral/hero4.svg',
      alt: 'Nurse with patient',
    },
  ];

  const challengeCards = [
    {
      image: '/assets/platformBehavioral/2section-1.svg',
      title: 'Hidden Distress',
      description: 'Many individuals mask early signs of emotional struggle until it reaches a breaking point.',
    },
    {
      image: '/assets/platformBehavioral/2section-2.svg',
      title: 'Limited Access',
      description: 'Shortage of trained professionals and long wait times make timely care difficult.',
    },
    {
      image: '/assets/platformBehavioral/2section-3.svg',
      title: 'Disconnected Data',
      description: 'Behavioral health information often remains separate from primary-care systems, limiting holistic insight.',
    },
    {
      image: '/assets/platformBehavioral/2section-4.svg',
      title: 'Low Engagement',
      description: 'Existing digital solutions struggle to maintain consistent participation or follow-through.',
    },
    {
      image: '/assets/platformBehavioral/2section-5.svg',
      title: 'Stigma & Awareness Gaps',
      description: 'Social stigma and lack of early education discourage people from seeking help.',
    },
    {
      image: '/assets/platformBehavioral/2section-6.svg',
      title: 'Reactive Care Models',
      description: 'Most systems respond after symptoms worsen, rather than focusing on early detection and prevention.',
    },
  ];

  const cardsData = [
    {
      image: '/assets/platformBehavioral/3section-1.svg',
      // icon: Card1Icon,
      heading: 'Detect Early',
      subheading: 'Detect developmental or growth delays, AI-based mood and stress analysis identifies early emotional shifts.'
    },
    {
      image: '/assets/platformBehavioral/3section-2.svg',
      // icon: Card2Icon,
      heading: 'Connect Better',
      subheading: 'Teletherapy, chat, and guided programs make support instantly accessible for everyone instantly.'
    },
    {
      image: '/assets/platformBehavioral/3section-3.svg',
      heading: 'Personalize Care',
      subheading: 'Tailored recommendations and behavioral plans adapt to each and every user’s needs in an effective way.'
    },
    {
      image: '/assets/platformBehavioral/3section-4.svg',
      heading: 'Sustain Wellness',
      subheading: 'Continuous insights and reminders keep users engaged in their journey and also recommendations and behavioral plans'
    },
  ];

  const outcomesCards = [
    {
      title: 'For Patients',
      benefits: [
        'AI-driven self-assessments for mental-state tracking.',
        'Personalized behavioral plans tailored to individual goals.',
        'Private, secure teleconsultations with licensed experts.',
      ],
      image1: '/assets/platformBehavioral/4section-1.svg',
      image2: '/assets/platformBehavioral/4section-2.svg',
    },
    {
      title: 'For Providers',
      benefits: [
        'Predictive analytics to prioritize at-risk patients.',
        'Unified care records integrating behavioral and physical data.',
        'Progress tracking and for improved outcomes.',
      ],
      image1: '/assets/platformBehavioral/4section-3.svg',
      image2: '/assets/platformBehavioral/4section-4.svg',
    },
  ];

  // const discoverCards = [
  //   {
  //     image: childCareImage,
  //     // icon: '👶',
  //     title: '👩Women Health Care',
  //     subtitle: ' Supporting women at every stage — from prevention to maternity.',
  //     link: '/child-care',
  //   },
  //   {
  //     image: childCareImage,
  //     // icon: '👶',
  //     title: '👶Child Health Care',
  //     subtitle: 'Supporting the next generation with connected pediatric care.',
  //     link: '/child-care',
  //   },
  // ];

  return (
    <div>
      {/* Image Gallery Section */}
        <ImageGallerySection
          title="Reimagining Behavioral Health with Empathy and Intelligence"
          images={galleryImages}
        />

        {/* <div className="h-32 md:h-40 lg:h-48 bg-white"></div> */}
        <div className="h-14 md:h-18 lg:h-22 bg-white"></div>

    
      {/* Challenges Section */}
      <ChallengesSection
        title="The State of"
        highlightedText="Behavioral Health"
        description="Even as awareness grows, access and continuity of mental-health care remain fragmented — Avexa bridges these gaps with connected, compassionate solutions."
        cards={challengeCards}
        showToday={true}
      />

<InfoCarouselSection
      backgroundColor="var(--primary-color)"
      title="Transforming Mental Health Through"
      highlightedText="Connected Intelligence"
      description="Avexa combines advanced analytics, AI empathy mapping, and digital engagement tools to create a seamless continuum of behavioral care — one that listens, learns, and supports every step of the journey."
      cards={cardsData}
    />

    {/* Outcomes Section */}
      <OutcomesSection
        title="Empowering Both"
        highlightedText="Patients and Providers"
        description="Avexa empowers individuals with self-understanding and equips professionals with intelligence for precise, proactive care."
        cards={outcomesCards}
      />

      <PrivacyEthicsSection />

    </div>
  );
};

export default BehavioralHealth;